'use client';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { TealiumUTag } from 'shared/types/tealium/TealiumUTag';
import ErrorIcon from '@/components/customercenter-ui/svgs/notifications/error';
import { triggerTealiumEvent, getPageUtagData } from '@/components/customercenter-ui/utils/tealiumUtils';
import { ErrorNotification } from '@/helpers/utils/notification';
import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import TableSection from './common/table/index';
import SearchType from './search-type';
import { FAILED, PAGE_TEXTS_KEYS, RESPONSE_BAD_REQUEST } from '../../../../../constants/constant';
import Loader from '../../ui/loader';
import { useToast } from '../../ui/use-toast';
import { GetTableData } from '../utils';

function Index(props: Readonly<any>) {
  const { toast } = useToast();
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  const router = useRouter();
  const selectedSearchType = useSearchParams()?.get('selectedSearchType') ?? '';
  const queueName = useSearchParams()?.get('queueName');
  const timeStamp = useSearchParams()?.get('timeStamp');
  const { pageData, pagePath } = props;
  const [dataFetchInProgress, setDataFetchInProgress] = useState<boolean>(false);
  const setAllRowsDataFuncRef = useRef(null);
  const setAllRowsDataRef = useRef(null) as any;
  const [isClientSide, setIsClientSide] = useState(false);
  const tbData = GetTableData({
    pagePath,
    pageData,
    Texts,
    selectedSearchType,
    queueName,
    setAllRowsDataFuncRef,
    setAllRowsDataRef,
  });
  const [allRowsData, setAllRowsData] = useState(tbData?.allRowsData) as any;
  setAllRowsDataFuncRef.current = setAllRowsData;

  useEffect(() => {
    let tealiumPageName = 'Customer Home';
    if (selectedSearchType && pagePath === 'customer-search') {
      tealiumPageName = 'Customer Search';
    } else if (!selectedSearchType && pagePath === 'order-search') {
      tealiumPageName = 'Order Home';
    }

    const pageLinkUtagData: TealiumUTag = getPageUtagData(tealiumPageName, selectedSearchType);

    triggerTealiumEvent(pageLinkUtagData);
  }, [selectedSearchType]);

  useEffect(() => {
    setIsClientSide(true);
    setDataFetchInProgress(false);
    setAllRowsData(tbData?.allRowsData);
    setAllRowsDataRef.current = tbData?.allRowsData;
  }, [pageData, timeStamp]);

  const onTabChange = useCallback((value: string) => {
    setDataFetchInProgress(true);
    router.push(`/${value}`);
  }, []);

  useEffect(() => {
    if (isClientSide) {
      if (pageData?.code === RESPONSE_BAD_REQUEST || pageData?.code === FAILED) {
        ErrorNotification(toast, {
          description: pageData?.message,
          action: <ErrorIcon className="h-5 w-5" />,
        });
      }
    }
  }, [isClientSide, pageData]);
  return (
    <section className="px-4 xl:mx-auto xl:max-w-[1400px]">
      {dataFetchInProgress && <Loader />}
      <SearchType
        pagePath={pagePath}
        setDataFetchInProgress={setDataFetchInProgress}
        onTabChange={onTabChange}
        setAllRowsDataRef={setAllRowsDataRef}
      />
      {!dataFetchInProgress && pageData && isClientSide && (
        <TableSection columnsData={tbData?.columnsData} allRowsData={allRowsData} pagePath={pagePath} />
      )}
    </section>
  );
}

export default Index;
